import { Component } from '@angular/core';
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FormDataHelper, TranslateHelper } from '@app/_helpers';
import { AuthenticationService } from '@app/_services/authentication.service';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { ClickDirective } from '../../../../shared/directives/click.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgClass, NgIf } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { SiteService } from '@app/_services';
import { TranslateService } from '@ngx-translate/core';
//import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
    selector: 'app-login',
    templateUrl: './page-login.component.html',
    styleUrls: ['./page-login.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [MatTabsModule, FormsModule, ReactiveFormsModule, NgIf, RouterLink, MatSlideToggleModule, MatIconModule, ClickDirective, TranslateModule, NgClass]
})
export class PageLoginComponent {

    constructor(
        private fb: UntypedFormBuilder,
        private authenticationService: AuthenticationService,
        private toast: ToastrService,
        private router: Router,
        private translateHelper: TranslateHelper,
        private authService: AuthenticationService,
        private toastr: ToastrService,
        private formDataHelper: FormDataHelper,
        private activatedRoute: ActivatedRoute,
        public siteService: SiteService,
        private translate: TranslateService
    ) {
    }

    tabIndex = 0;
    form = this.fb.group({
        email: [null, [Validators.required]],
        password: [null, Validators.required]
    });

    registerForm = this.fb.group({
        firstname: ['', [Validators.required]],
        lastname: ['', [Validators.required]],
        mobile: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(6)]],
    });

    submitted = false
    returnUrl: string;

    backgroundColor = '#20324e';
    companyLogo;
    loginOnly = false;

    ngOnInit(): void {
        this.activatedRoute.data.subscribe(res=>{
            this.loginOnly = res.loginOnly;
        })
        if (_.includes(this.router.url, 'register')) {
            this.tabIndex = 1;
        }
        this.returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || '/';
        if (this.activatedRoute.snapshot.queryParams['e']) {
            const email = atob(this.activatedRoute.snapshot.queryParams['e']);
            this.registerForm.get('email').patchValue(email);
        }
        if (!this.siteService.siteSetting?.main || this.siteService.siteSetting?.companyId?.length > 0) {
            this.backgroundColor = this.siteService?.siteSetting?.header?.backgroundColor || this.backgroundColor;
            this.companyLogo = 'assets/svg/logo-main.svg';
        }
    }

    login() {
        this.submitted = true;

        if (this.form.invalid) return;
        //this.$gaService.event('submit', 'user_login_form', this.form.value.email);
        this.authenticationService.login({ ...this.form.value, ...(window as any)?.mobilePlayerId ? { mobilePlayerId: (window as any)?.mobilePlayerId } : {} }).subscribe((user) => {
            if (user.code == 400) {
                this.toast.error(this.translateHelper.getTranslation("err_name_password"));
                return;
            }

            if (_.isEmpty(user.data)) {
                this.toast.error("connot login");
                return;
            }
            this.toast.success(`Welcome Back ${user.data.name}`);
            this.router.navigate([this.returnUrl]);
        }, (error) => {
            this.toast.error(this.translateHelper.getTranslation("err_name_password"));
        });
    }

    onToggle(evento) {
        if (evento.checked) {
            // Redirect to vendor form instead of showing business fields
            this.router.navigate(['/vendor-form/register']);
        }
    }

    submit(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();

        /*  if (this.confirmPassword != this.password) {
             this.toastr.error('Passwords must match');
             return;
         } */

        if (this.registerForm.invalid) {
            // Show specific error messages
            const controls = this.registerForm.controls;
            if (controls['firstname'].errors?.required) {
                this.toastr.error(this.translateHelper.getTranslation('first_name_required'));
            } else if (controls['lastname'].errors?.required) {
                this.toastr.error(this.translateHelper.getTranslation('last_name_required'));
            } else if (controls['email'].errors?.required) {
                this.toastr.error(this.translateHelper.getTranslation('email_required'));
            } else if (controls['email'].errors?.email) {
                this.toastr.error(this.translateHelper.getTranslation('enter_valid_email'));
            } else if (controls['mobile'].errors?.required) {
                this.toastr.error(this.translateHelper.getTranslation('mobile_required'));
            } else if (controls['mobile'].errors?.pattern) {
                this.toastr.error(this.translateHelper.getTranslation('mobile_numbers_only'));
            } else if (controls['password'].errors?.required) {
                this.toastr.error(this.translateHelper.getTranslation('password_required'));
            } else if (controls['password'].errors?.minlength) {
                this.toastr.error(this.translateHelper.getTranslation('password_min_length'));
            } else {
                this.toastr.error(this.translateHelper.getTranslation('fill_all_fields'));
            }
            return;
        }

        const routerUrl = this.router.url;
        const routerLang = routerUrl.includes('/ar/') || routerUrl.startsWith('/ar') ? 'ar' :
                          routerUrl.includes('/en/') || routerUrl.startsWith('/en') ? 'en' : null;
        const currentLang = this.translate.currentLang ||
                           routerLang ||
                           localStorage.getItem('language') ||
                           document.documentElement.lang ||
                           (window.location.pathname.includes('/ar') ? 'ar' : 'en');

        const formValue = { ...this.registerForm.value, language: currentLang };
        let formData = this.formDataHelper.ToFormData(formValue);

        this.authService.register(formData).subscribe((response: any) => {

            if (response.code == 400) {
                this.toastr.error(response.msg);

            } else if (response.code == 200) {
                // Show success message with business registration option
                const businessMsg = this.translateHelper.getTranslation('business_registration_notice');
                const btnText = this.translateHelper.getTranslation('become_vendor_today');
                const clickHere = this.translateHelper.getTranslation('click_here');
                const successHtml = `
                    <div style="margin-bottom: 12px;"><strong>${response.msg}</strong></div>
                    <div style="font-size: 13px; color: #fff; margin-bottom: 8px;">${businessMsg}</div>
                    <div style="font-size: 13px;">${clickHere} <a href="/vendor-form/register" class="vendor-link">${btnText}</a></div>
                `;
                this.toastr.success(successHtml, '', { 
                    enableHtml: true, 
                    timeOut: 15000,
                    closeButton: true,
                    tapToDismiss: false
                });
                this.router.navigate(['/']);
                this.authService.login({ email: this.registerForm.value.email, password: this.registerForm.value.password }).subscribe();
            }

        }, (error) => {
            this.toastr.error(error.error.msg);
        })
    }

    // Prevent non-numeric characters in mobile field
    onMobileInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        input.value = input.value.replace(/[^0-9]/g, '');
        this.registerForm.get('mobile').setValue(input.value);
    }

    get password() {
        return this.registerForm.get('password').value;
    }
    get confirmPassword() {
        return this.registerForm.get('confirmPassword').value;
    }
}
